// Renders plain text, turning http(s) URLs into links that open in a new window.
const URL_SPLIT = /(https?:\/\/[^\s]+)/g;
const isUrl = (s) => /^https?:\/\//.test(s);
const clean = (u) => u.replace(/[.,;:!?)\]]+$/, "");

export function Linkify({ text, className }) {
  if (!text) return null;
  const parts = String(text).split(URL_SPLIT);
  return (
    <span className={className} style={{ whiteSpace: "pre-line" }}>
      {parts.map((part, i) => {
        if (!isUrl(part)) return part;
        const href = clean(part);
        const trailing = part.slice(href.length);
        return (
          <span key={i}>
            <a href={href} target="_blank" rel="noopener noreferrer"
              className="text-[#1F3C88] underline underline-offset-2 hover:text-[#F7941D] break-words">{href}</a>
            {trailing}
          </span>
        );
      })}
    </span>
  );
}
